import React from "react";
import { useNavigate } from "react-router";

export default function DashboardItem(props) {
  const navigate = useNavigate();

  const {
    children,
    title,
    redirectTo,
    shouldShow = true,
    id,
    navigationState,
  } = props;

  let dashboardItemClassName =
    "group flex flex-col place-content-center place-items-center text-center bg-primary text-secondary shadow-xs border border-primary rounded-xl py-10 cursor-pointer hover:shadow-lg hover:text-brand transition-all";

  if (!shouldShow) {
    dashboardItemClassName = "hidden";
  }

  return (
    <div
      id={id}
      className={dashboardItemClassName}
      onClick={() => {
        if (redirectTo) {
          navigate(redirectTo, navigationState);
        }
      }}
    >
      {children}
      <h3 className="font-medium text-lg text-secondary group-hover:text-brand transition-all">
        {title}
      </h3>
    </div>
  );
}
